import { defineMessages } from "react-intl";

/**
 * SFCC-11723 — i18n message catalog for the LearningCenterArticleBreadcrumb
 * block. As with the goal/module breadcrumb, `trail.ts` stays framework-free and
 * is fed the already-formatted static labels from the component so "Home", the
 * HSA-specific "HSA Learning Center", and the "Articles" crumb are message-keyed
 * and per-site overridable.
 */
const messages = defineMessages({
  home: {
    id: "learningCenter.articleBreadcrumb.home",
    defaultMessage: "Home",
  },
  learningCenter: {
    id: "learningCenter.articleBreadcrumb.learning_center",
    defaultMessage: "HSA Learning Center",
  },
  articles: {
    id: "learningCenter.articleBreadcrumb.articles",
    defaultMessage: "Articles",
  },
});

export default messages;
